// 组织级联选择器公共方法（参照 system/user：有子级的节点额外生成一条「可选的扁平项」，实现父级/顶级也能选中）

// 把 client.list() 返回的组织树转成 el-cascader 的 options
// 有子级的节点会同时生成：一条扁平项（可选中）+ 一条层级项（可展开下级）
export function buildClientOptions(list) {
	const result = [];
	(list || []).forEach(item => {
		if (item.children && item.children.length) {
			// 扁平项：父级/顶级可选中
			result.push({ value: item.id, label: item.name });
			// 层级项：可展开下级
			result.push({ value: item.id, label: item.name, children: buildClientOptions(item.children) });
		} else {
			// 叶子
			result.push({ value: item.id, label: item.name });
		}
	});
	return result;
}

// 根据叶子/节点 id 反查完整级联路径（用于编辑回显）
export function findClientPath(options, targetId, path = []) {
	for (const node of options) {
		const p = [...path, node.value];
		if (node.value == targetId) return p;
		if (node.children && node.children.length) {
			const found = findClientPath(node.children, targetId, p);
			if (found) return found;
		}
	}
	return null;
}
